export default __webpack_public_path__ + "static/media/ls2_g02.8d3250a0.png";